/**
 * A deploy deletes the old fingerprinted chunks, so a tab left open across one
 * requests files that no longer exist. The browser caches the failed import,
 * so reloading to pick up a fresh manifest is the only recovery.
 */

const RELOAD_KEY = 'chunk_error_reload'

export function isChunkLoadError(error: unknown): boolean {
  return (
    error instanceof Error &&
    /valid JavaScript MIME type|dynamically imported module|module script failed|Loading (CSS )?chunk/.test(
      error.message,
    )
  )
}

/** Reloads, unless we just did and it clearly didn't help. */
export function reloadOnce(): boolean {
  const last = Number(sessionStorage.getItem(RELOAD_KEY))
  if (Date.now() - last < 10_000) return false
  sessionStorage.setItem(RELOAD_KEY, String(Date.now()))
  window.location.reload()
  return true
}
